import { useEffect, useState } from "react";
import { serverTimeAt, useGame } from "./store.ts";
import type { PhaseView } from "./types.ts";

/**
 * Re-renders every `ms` and returns the server's clock: corrected by the measured offset, and
 * running at the game clock's speed in dev (DEV_TIME_SCALE).
 */
export function useServerNow(ms = 250): number {
  const clock = useGame((s) => s.clock);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return serverTimeAt(clock, now);
}

/** Milliseconds left in a phase (frozen while paused), or null when it has no timer. */
export function remainingMs(
  phase: Pick<PhaseView, "deadline" | "paused" | "remainingMs">,
  now: number,
): number | null {
  if (phase.paused) return phase.remainingMs;
  if (phase.deadline === null) return null;
  return Math.max(0, phase.deadline - now);
}

/** m:ss, rounding up so "0:00" only shows when time is really up. */
export function formatClock(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}
